import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';

const ScrollButton = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 300) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 300) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo(0, 300);
  };

  const scrollBottom = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.scrollHeight;
    const scrollHeight = documentHeight - 50 - windowHeight;
    
    window.scrollTo(0, scrollHeight);
    
  };

  window.addEventListener('scroll', checkScrollTop);

  return (
    <div className="z-20 fixed bottom-20 right-4 flex flex-col items-center">
      {showScroll && (
        <button
          className="bg-white rounded-full p-2 shadow-md cursor-pointer mb-2"
          onClick={scrollTop}
        >
          <FaChevronUp size={24} />
        </button>
      )}
      {showScroll && (
        <button
          className="bg-white rounded-full p-2 shadow-md cursor-pointer"
          onClick={scrollBottom}
        >
          <FaChevronDown size={24} />
        </button>
      )}
    </div>
  );
};

export default ScrollButton;
